import React, { useState } from 'react'
import withRouter from 'hoc/withRouter';
import { withRemoteDataAndSpinner } from 'hoc/withRemoteDataAndSpinner';
import tourPackagesService from 'services/admin/tour-packages.service';
import { FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import _ from 'lodash';
import { useLoadAll } from 'hooks/useLoadAll';
import './scss/RoomAllocation.scss';
import { DndContext, useDraggable, useDroppable } from '@dnd-kit/core';
import roomAllocationsService from 'services/admin/room-allocations.service';
import { toast } from 'react-toastify';
import customersService from 'services/admin/customersService';
import { AxiosError } from 'axios';
import roomsService from 'services/admin/roomsService';
import moment from 'moment';
import hotelsService from 'services/admin/hotelsService';
import { diffInDays } from 'helpers/dateHelper';
import subOrdersService from 'services/admin/sub-orders.service';
import { SUB_ORDER_TYPE } from 'enums/enums';

const RoomAllocation = ({
    data: {
        tourPackage,
        subOrders,
        roomAllocations,
        rooms,
        hotel
    },
    router: {
        params: {
            hotelID
        },
        navigate
    }
}) => {
    // Заполненность номеров
    const [uiRoomAllocations, setUiRoomAllocations] = useState(roomAllocations.data)

    // Туристы в турпакете
    const initialCustomers = subOrders.rows ?
        subOrders.rows.flatMap(so => so.orderItems).map(c => ({
            ...c.customer,
            subOrderID: c.subOrderID,
        })) :
        []
    const initialCustomersMap = initialCustomers.reduce((acc, customer) => {
        acc[customer.id] = customer;
        return acc;
    }, {})

    const [uiCustomers, setUiCustomers] = useState(subOrders.rows ?
        subOrders.rows.flatMap(so => so.orderItems).filter(c => !uiRoomAllocations.map(ra => ra.customerID).includes(c.customerID)).map(c => ({
            ...c.customer,
            subOrderID: c.subOrderID,
        })) :
        [])

    console.log("uiCustomers=>", uiCustomers)


    const handleDrop = async (event) => {
        console.log("dropped here=>", event)
        const { active, over } = event;
        if (!over) return;

        const customerID = active.id;
        const roomID = over.id.replace("room-", "")

        console.log("handleDrop", {
            customerID,
            roomID
        })

        if (!customerID || !roomID) {
            return;
        }

        try {
            const { data: newRoomAllocation } = await roomAllocationsService.post({
                customerID,
                roomID,
                hotelID: hotelID,
                tourPackageID: tourPackage.id
            })

            console.log("Номер записан: ", newRoomAllocation)

            if (newRoomAllocation.roomAllocation) {
                setUiRoomAllocations([...uiRoomAllocations, newRoomAllocation.roomAllocation])
            }
            // Remove customer from customers list
            setUiCustomers(uiCustomers.filter(customer => customer.id !== customerID));
        } catch (error) {
            console.error("Ошибка при распределении номера: ", error);
            if (error instanceof AxiosError) {
                toast.error(error.response?.data?.message);
            } else {
                toast.error("Ошибка при распределении номера: " + error.message);
            }
        }
    }

    const handleDeleteRoomAllocation = async (roomAllocation) => {
        try {
            const confirmed = window.confirm(`Вы точно хотите удалить ${roomAllocation.customer?.lastName} ${roomAllocation.customer?.firstName}?`)
            if (confirmed) {
                await roomAllocationsService.delete(roomAllocation.id);
                toast.success("Распределение успешно удалено!");
                setUiRoomAllocations(uiRoomAllocations.filter(ra => ra.id !== roomAllocation.id));
                setUiCustomers([...uiCustomers, roomAllocation.customer]);
            }
        } catch (error) {
            console.error("Ошибка при удалении номера: ", error);
        }
    }

    const buildBoard = () => {
        const roomsByType = _.groupBy(rooms?.data || [], 'roomTypeID');
        const roomAllocationsByRoomID = _.groupBy(uiRoomAllocations || [], 'roomID');


        return <DndContext onDragEnd={handleDrop}>
            <section className='flex m-t-16 board'>
                <div className="" style={{
                    flex: 0.8
                }}>
                    <div className='w-100 flex flex-wrap gap-4'>
                        {Object.keys(roomsByType).map(roomTypeID => {
                            return <div key={roomTypeID} className='flex-1 board-column'>
                                <div className="board-column-header">{roomsByType[roomTypeID][0].roomType.name}
                                    <span style={{
                                        fontSize: 12,
                                        color: "gray",
                                        marginLeft: 4
                                    }}>
                                        (Количество номеров: {roomsByType[roomTypeID].length})</span>
                                </div>
                                <div className="board-column-content">
                                    {roomsByType[roomTypeID].map(room => {
                                        return <DroppableRoom key={room.id} room={room}
                                            roomAllocations={roomAllocationsByRoomID[room.id]}
                                            handleDeleteRoomAllocation={handleDeleteRoomAllocation}
                                            initialCustomersMap={initialCustomersMap}
                                        />
                                    })}
                                </div>
                            </div>
                        })}
                    </div>
                </div>
                {/* Возможность drag and drop туристов в номера */}
                <section className="drag-and-drop-container board-column" style={{
                    flex: 0.2,
                    marginLeft: 4
                }}>
                    <div className="board-column-header">Туристы <span style={{
                        fontSize: 12,
                        color: "gray",
                        marginLeft: 4,
                    }}>
                        ({uiCustomers.length})</span></div>
                    <div className="board-column-content">
                        {uiCustomers.filter(customer => customer.id).map(customer => {
                            return <Draggable key={customer.id} id={customer.id}
                            >
                                <div style={{
                                    lineHeight: 1.5,
                                    fontSize: 10,
                                    color: 'var(--text-color) !important',
                                }}><span style={{ fontSize: 10, color: "gray", marginRight: 4 }}>#{initialCustomersMap[customer.id].subOrderID}</span> {customer.lastName} {customer.firstName}
                                    <span style={{
                                        fontSize: 10,
                                        color: "gray",
                                        marginLeft: 4,
                                    }}>{getCustomerType(customer)}/{customer.gender}</span>
                                </div>
                            </Draggable>
                        })}
                    </div>
                </section>
            </section>
        </DndContext>
    }

    const hotelStayPeriod = () => {
        const tourToHotel = tourPackage.hotels.find(h => h.id === hotelID);
        const startDate = _.get(tourToHotel, 'TourToHotel.startDate', null);
        const endDate = _.get(tourToHotel, 'TourToHotel.endDate', null);

        return startDate && endDate && <div>
            <TextField label="Период" value={moment(startDate).format('DD.MM.YYYY') + ' - ' + moment(endDate).format('DD.MM.YYYY')} disabled
                helperText={`Длительность: ` + diffInDays(endDate, startDate) + ' дней'}
            />
        </div>
    }

    return (
        <div className='room-allocation'>
            <h3>Размещение туристов по номерам в гостинице</h3>
            <section className='m-t-32'>
                <div className='flex flex-row gap-4'>
                    {/* Tourpackage */}
                    {tourPackage ? <div>
                        <TextField label="Название турпакета" value={tourPackage.name} disabled />
                    </div> : null}
                    <div>
                        {tourPackage.hotels && <div className='flex-1'>
                            <FormControl>
                                <InputLabel>Отель</InputLabel>
                                <Select
                                    value={hotelID}
                                    label="Отель"
                                    onChange={(event) => {
                                        // field.onChange(event.target.value);
                                        navigate(`/admin/tour-packages/allocation/${tourPackage.id}/${event.target.value}`);
                                        window.location.reload();
                                    }}
                                >
                                    {tourPackage.hotels.map(hotel => {
                                        return <MenuItem key={hotel.id} value={hotel.id}>{hotel.name}</MenuItem>
                                    })}
                                </Select>
                            </FormControl>
                        </div>
                        }
                    </div>
                    <div>
                        {hotelStayPeriod()}
                    </div>
                </div>
            </section>
            <section className='m-t-16'>
                <div className="total-reserved-rooms flex flex-row gap-4">
                    <div>Общее количество занятых номеров: <strong>{uiRoomAllocations.length}</strong></div> /
                    <div>Общее количество свободных номеров: <strong>{_.sumBy(rooms.data, 'capacity') - uiRoomAllocations.length}</strong></div>
                </div>
            </section>
            {buildBoard()}
        </div>
    )
}


function Draggable({ id, children }) {
    const { attributes, listeners, setNodeRef, transform, transition } =
        useDraggable({ id });

    const style = {
        transform: transform
            ? `translate3d(${transform.x}px, ${transform.y}px, 0)`
            : undefined,
        transition,
        background: "var(--background-color)",
        padding: "8px 12px",
        marginBottom: 8,
        borderRadius: 8,
        cursor: "grab",
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
    };

    return (
        <div ref={setNodeRef} {...attributes} {...listeners} style={style}>
            {children}
        </div>
    );
}

function DroppableRoom({ room, roomAllocations, handleDeleteRoomAllocation, initialCustomersMap }) {
    const { setNodeRef, isOver } = useDroppable({ id: `room-${room.id}` });

    console.log("initialCustomersMap=>", initialCustomersMap)
    console.log("roomAllocations=>", roomAllocations)

    return <div ref={setNodeRef}
        style={{ background: isOver ? "lightgreen" : undefined }}
        className='board-item'
    >
        <div className='m-b-8'>
            <strong style={{
                lineHeight: 1.5,
            }}>Номер: &#x2116;{room.number}</strong>
            <div style={{
                color: room.capacity - (roomAllocations?.length || 0) > 0 ? "red" : "green"
            }}>
                Заполненность: ({roomAllocations?.length || 0}/{room.capacity})
            </div>
        </div>
        <div>
            <div style={{
                fontSize: 12,
                color: "gray",
                lineHeight: 1.5,
                marginBottom: 8,
            }}>Заселенные туристы:</div>
            {roomAllocations?.map(roomAllocation => {
                return <div style={{
                    lineHeight: 2,
                    fontSize: 10,
                }} key={roomAllocation.id} onClick={() => {
                    handleDeleteRoomAllocation(roomAllocation);
                }}>
                    <div style={{
                        background: "var(--background-color)",
                        padding: "4px 8px",
                        borderRadius: 4,
                        color: "var(--text-color)",
                        marginBottom: 4,
                    }}>
                        <span><span style={{ fontSize: 10, color: "gray", marginRight: 4 }}>#{initialCustomersMap ? initialCustomersMap[roomAllocation.customerID]?.subOrderID : null}</span> {roomAllocation.customer?.lastName} {roomAllocation.customer?.firstName}</span>
                        <span style={{
                            fontSize: 12,
                            color: "gray",
                            marginLeft: 4,
                        }}>
                            {getCustomerType(roomAllocation.customer)}/{roomAllocation.customer?.gender}
                        </span>
                    </div>
                </div>
            })}
        </div>
    </div>
}


export default withRouter(
    withRemoteDataAndSpinner(RoomAllocation, (router) => {
        const orgID = localStorage.getItem("orgID");
        console.log("orgID=>", orgID);

        let requests = {
            tourPackage: () => tourPackagesService.get(router.params.tourPackageID),
            subOrders: () => subOrdersService.getAllByOrgID(orgID, {
                itemType: SUB_ORDER_TYPE.TOURPACKAGE,
                itemID: router.params.tourPackageID,
            }),
            roomAllocations: () => roomAllocationsService.getAll({
                tourPackageID: router.params.tourPackageID,
                hotelID: router.params.hotelID
            }),
            rooms: () => roomsService.getAll({
                hotelID: router.params.hotelID
            }),
            hotel: () => hotelsService.get(router.params.hotelID)
        }
        return useLoadAll(requests);
    })
);


function getCustomerType(customer) {
    console.log("customer: ", customer.birthdate)
    // 18 years old or older
    const birthdate = moment(customer.birthdate, 'YYYY-MM-DD');
    const age = Math.abs(birthdate.diff(moment(), 'years'));
    if (age >= 18) {
        return 'ADL';
    } else if (age >= 2) {
        return 'CHD';
    }
    return 'INF';
}